var _dec, _dec2, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service from '@ember/service';
import { MerchantCatalogConnectFrontend } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/frontend/catalog_connect_frontend';
import rpc from '@square/dashboard-utilities/clients/rpc';
import { feature } from '@square/ember-features/macros';
import { X_CATALOG_API_SUPPORTED_FEATURES_COMBOS, X_CATALOG_API_SUPPORTED_FEATURES_HEADER_NAME, X_CATALOG_API_SUPPORTED_FEATURES_PROGRAM_ELIGIBILITY } from '@square/dashboard-items-data/utils/api-constants';

// Use the same version as the search API in ./merchant-catalog-dashboard-fe.ts
const SEARCH_API_VERSION = '2051-01-04';

/**
 * This service wraps a catalog-connect-v2 client for the MerchantCatalogConnectFrontend service.
 *
 * A service was necessary to allow us to lock to a version header for endpoints under the service.
 * Allowing for consumption of the endpoints directly without using the ember data store + adaptors.
 *
 * proto: https://prototype.sqprod.co/#/docs/squareup.connect.v2.merchant_catalog.frontend.MerchantCatalogConnectFrontend
 */
let MerchantCatalogConnectFe = (_dec = feature('catalog/release-combos-beta-2025'), _dec2 = feature('catalog/program-eligibility-attribute'), _class = class MerchantCatalogConnectFe extends Service {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "client", null);
    _initializerDefineProperty(this, "isCombosBeta2025Enabled", _descriptor, this);
    _initializerDefineProperty(this, "isProgramEligibilityEnabled", _descriptor2, this);
  }
  getClient() {
    if (!this.client) {
      this.client = this._createClient();
    }
    return this.client;
  }
  get catalogFeaturesHeaderValue() {
    const apiFeatures = [];
    if (this.isCombosBeta2025Enabled) {
      apiFeatures.push(X_CATALOG_API_SUPPORTED_FEATURES_COMBOS);
    }
    if (this.isProgramEligibilityEnabled) {
      apiFeatures.push(X_CATALOG_API_SUPPORTED_FEATURES_PROGRAM_ELIGIBILITY);
    }
    return apiFeatures.length > 0 ? apiFeatures.join(',') : undefined;
  }
  _createClient() {
    const additionalHeaders = new Map();
    additionalHeaders.set('Square-Version', SEARCH_API_VERSION);
    if (this.catalogFeaturesHeaderValue) {
      additionalHeaders.set(X_CATALOG_API_SUPPORTED_FEATURES_HEADER_NAME, this.catalogFeaturesHeaderValue);
    }
    return MerchantCatalogConnectFrontend.create(rpc(undefined, {
      additionalHeaders
    }));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isCombosBeta2025Enabled", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isProgramEligibilityEnabled", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { MerchantCatalogConnectFe as default };